var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 7.4c-7.1 0-12.9 5.8-12.9 12.9s5.8 12.9 12.9 12.9 12.9-5.8 12.9-12.9S27.4 7.4 20.3 7.4zm1.5 20.4h-3.1V17.4h3.1v10.4zm.2-12.5c-.1.2-.2.4-.4.6-.2.2-.4.3-.6.4s-.5.1-.7.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6s-.1-.4-.1-.7c0-.3 0-.5.1-.7s.2-.4.4-.6.4-.3.6-.4c.2-.1.5-.1.7-.1.3 0 .5 0 .7.1.2.1.4.2.6.4.2.2.3.4.4.6s.1.5.1.7c0 .2 0 .4-.1.7z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Info.svg